module.exports = __webpack_public_path__ + "img/banner-1.f91f96cb.jpg";